import { useState } from "react";
import { files } from "../services/files";

interface CustomUploads {
  [key: string]: {
    file: any;
    url?: string;
  };
}

type HandleFileChange = (newFile: any, name: string, url?: string) => void;
type HandleUpload = ({
  name,
  editing,
  category,
  required,
}: {
  name: string;
  editing?: boolean;
  category?: string;
  required?: boolean;
}) => Promise<any>;

type HandleCleanUploads = () => void;

interface CustomUploadHook {
  cleanUploads: HandleCleanUploads;
  handleFileChange: HandleFileChange;
  handleUpload: HandleUpload;
  uploads: CustomUploads;
  handleRemove: any;
}

const useCustomUpload = (): CustomUploadHook => {
  const [uploads, setUploads] = useState<CustomUploads>({});

  const handleFileChange: HandleFileChange = (newFile, name, url) => {
    if (url) {
      setUploads((prevUploads) => ({
        ...prevUploads,
        [name]: {
          file: newFile,
          url: url,
          uid: name,
        },
      }));
    } else {
      setUploads((prevUploads) => ({
        ...prevUploads,
        [name]: {
          file: newFile,
        },
      }));
    }
  };

  const handleRemove = (name: string) => {
    let newUploads = { ...uploads };
    delete newUploads[name];
    setUploads({ ...newUploads });
  };

  const handleUpload: HandleUpload = async ({
    name,
    editing = false,
    category = "users",
    required = true,
  }) => {
    if (!name) {
      throw new Error("El archivo es requerido.");
    }

    const uploadData = uploads?.[name];

    if (!uploadData?.file?.name && required && !editing) {
      throw new Error("El archivo es requerido.");
    }

    if (uploadData?.file?.name) {
      return await files({
        file: uploadData.file,
        category,
      });
    }

    if (editing && uploadData?.url) {
      return "";
    }

    if (!uploadData?.file?.name && !required) {
      return "";
    }

    throw new Error("El archivo es requerido.");
  };

  const cleanUploads: HandleCleanUploads = () => {
    setUploads({});
  };

  return {
    cleanUploads,
    handleFileChange,
    handleUpload,
    uploads,
    handleRemove,
  };
};

export default useCustomUpload;
